import Icon from '../components/Icon.vue'

Icon.register({"chevron-circle-left":{"width":512,"height":512,"paths":[{"d":"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM142.1 273L277.6 408.5C287 417.9 302.2 417.9 311.5 408.5L328.5 391.5C337.9 382.1 337.9 366.9 328.5 357.6L226.9 256 328.5 154.4C337.9 145 337.9 129.8 328.5 120.5L311.5 103.5C302.1 94.1 286.9 94.1 277.6 103.5L142.1 239C132.7 248.4 132.7 263.6 142.1 273z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-left.js
// module id = gAoa
// module chunks = 0